// src/components/personal/sections/SettingsSection/AppSettings/utils.ts
import { useTranslation } from 'react-i18next';
import { SelectOption } from '../types';
import { Currency, Timezone } from './types';
import timezones from '../timezones.json';
import currencies from '../currencies.json';

/**
 * Hook для получения данных для выпадающих списков
 */
export function useFormOptions() {
  // Загружаем несколько пространств имен для корректной работы с переводами
  const { t: tBusinessTypes } = useTranslation('business_types');
  const { t: tCurrencies } = useTranslation('currencies');
  
  // Получаем типы бизнеса из переводов с явным указанием пространства имен
  const businessTypes: SelectOption[] = [
    { value: 'none', label: tBusinessTypes('none') },
    { value: 'restaurant', label: tBusinessTypes('restaurant') },
    { value: 'hotel', label: tBusinessTypes('hotel') },
    { value: 'barbershop', label: tBusinessTypes('barbershop') },
    { value: 'food_horeca', label: tBusinessTypes('food_horeca') },
    { value: 'teeth_clinic', label: tBusinessTypes('teeth_clinic') },
    { value: 'spa_wellness', label: tBusinessTypes('spa_wellness') },
    { value: 'gym_fitness', label: tBusinessTypes('gym_fitness') },
    { value: 'event_ticketing', label: tBusinessTypes('event_ticketing') },
    { value: 'retail_store', label: tBusinessTypes('retail_store') },
  ];
  
  // Подготавливаем временные зоны из JSON
  const timeZones: Timezone[] = timezones;
  
  // Подготавливаем валюты из JSON и переводов с явным указанием пространства имен
  const currencyOptions: SelectOption[] = (currencies as Currency[]).map(currency => ({
    value: currency.code,
    label: tCurrencies(currency.code, { defaultValue: currency.name })
  }));
  
  return {
    businessTypes,
    timeZones,
    currencies: currencyOptions
  };
}

/**
 * Возвращает форматированную справку по формату инструкций для ассистента
 */
export function getAssistantInstructionsHelp(t: any): string {
  return t('assistant_instructions_help', {
    defaultValue: `Инструкции для ассистента помогают настроить алгоритм работы с клиентами. 
    Вы можете указать специфику вашего бизнеса, особенности обработки заказов, 
    часто задаваемые вопросы и ответы на них. Чем подробнее вы опишете инструкции, 
    тем эффективнее будет работать автоматизация.`
  });
}

/**
 * Фильтрует и валидирует телефонный номер
 */
export function formatPhoneNumber(phone: string): string {
  // Удаляем все, кроме цифр и символа +
  return phone.replace(/[^\d+]/g, '');
}

/**
 * Проверяет валидность email
 */
export function isValidEmail(email: string): boolean {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}